<template>
<!-- 红色学堂 -->
    <div class="red_school">
        <div class="red_title">
            <div class="red_left">
                服务之窗
            </div>
            <div class="more" @click="showPage">
                查看更多 >
            </div>
        </div>
        <div class="red_list">
            <div class="list_item " v-for="(item, index) in list" :key="index" @mouseover=" hoverIndex = index" @mouseout=" hoverIndex = null"
                @click="showStudy(item.school_id)"
            >
                <div class="img_content_box">
                    <div :class="hoverIndex == index ? 'hvr-grow' : '' ">
                        <img :src="item.school_img" v-if="item.school_img && item.school_img.indexOf('http') != -1" alt="">
                        <img :src="$ImgUrl + item.school_img" v-if="item.school_img && item.school_img.indexOf('http') == -1" alt="">
                        <img src="../../assets/static/index/left_nav_bg3.png" v-if="!item.school_img" alt="">
                    </div>
                </div>
                <div class="list_title" :class="hoverIndex == index ? 'activeItem' : '' ">
                    {{ item.school_title }}
                </div>
                <div class="list_time">
                    <div class="time_left">
                        <span class="el-icon-timer"></span> 课时: {{ item.time }}分钟
                    </div>
                    <div class="time_right">
                        <span class="el-icon-right"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                list: [],
                hoverIndex: null,
            }
        },
        mounted () {
            this.getList()
        },
        methods: {
            async getList() {
                let res = await this.$axios.post("/lencon/pc/index/redSchool")
                if ( res.data.code == 1 ) {
                    this.list = res.data.res
                }
            },
            showPage() {
                this.$router.push("/RedSchool")
            },

            // 去红色血糖发
            showStudy( id ) {
                this.$router.push(`/studyDetail/${id}`)
            }
        },
    }
</script>

<style lang="scss" scoped>
@import "../../assets/css/main.scss";

.activeItem {
    color: #2767c4 ;
    font-weight: bold;
}
.red_school {
    width: 1200px;
    box-sizing: border-box;
    overflow: hidden;
    margin: 0 auto;
    .red_title {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 0;
        border-bottom: 1px solid #2767c4 ;
        .red_left {
            font-size: 24px;
            font-weight: bold;
            color: #2767c4 ;
        }
        .more {
            font-size: 14px;
            color: #D3D3D3;
            cursor: pointer;
        }
    }
    .red_list {
        padding: 20px 0;
        width: 100%;
        display: flex;
        justify-content: space-between;
        .list_item {
            width: 285px;
            // height: 170px;
            cursor: pointer;
            border: 1px solid #EEEEEE;
            .img_content_box {
                width: 285px;
                    height: 170px;
                overflow: hidden;
                img {
                    width: 285px;
                    height: 170px;
                }
            }
            .list_title {
                padding: 10px;
                height: 80px;
                font-size: 18px;
                @include MultipleRows(2);
            }
            .list_time {
                padding: 20px ;
                border: 1px solid #EEEEEE;
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: 14px;
                color: #9b9b9b;
            }
        }
    }
}
</style>